module.exports = __webpack_public_path__ + "static/img/positive.ab5e4be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/positive.gif
// module id = xvK7
// module chunks = 1